<div class="mat-body text-center">
    <button type="button" class="btn-close mat-elevation-z0" mat-icon-button (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>

    <h2 class="mat-headline">
        <i class="icon-check green-icon-check mb-3"></i>
        {{ 'dialog.confirm-contract.confirmation'|translate }}
    </h2>

    <ng-container>
        <p class="mb-3" [innerHTML]="'dialog.confirm-contract.confirm'|translate:{name: data.client.name + ' ' + data.client.surname}"></p>
        <p class="text-left mb-5">
            <small class="text-muted">
                <i [innerHTML]="'dialog.confirm-contract.confirm-note'|translate"></i>
            </small>
        </p>
    </ng-container>

    <button type="button" class="mat-elevation-z0" mat-raised-button color="blue" [mat-dialog-close]="true">
        <span>{{ 'dialog.confirm-contract.yes-confirm'|translate }}</span>
    </button>
</div>
